import React from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import { useState, useEffect } from "react";
import {
  usePayoutMethods,
  useDivisions,
  createEvent,
  createEventDivisions,
  useCourses,
  useGames,
  useThrowScoringModes,
} from "../util/db";
import { useLayouts } from "../util/db";
import EventCreateFormStep1 from "./EventCreateFormStep1";
import EventCreateFormStep2 from "./EventCreateFormStep2";
// import EventCreateFormStep4 from "./EventCreateFormStep4";
// import EventCreateFormStep3 from "./EventCreateFormStep3";
import EventCreateFormStep5 from "./EventCreateFormStep5";
import EventCreateFormStep6 from "./EventCreateFormStep6";
import EventCreateFormStep7 from "./EventCreateFormStep7";
import EventCreateFormFooter from "./EventCreateFormFooter";
import EventCreateFormNav from "./EventCreateFormNav";
import EventCreateFormAlertNoName from "./EventCreateFormAlertNoName";
import EventCreateFormAlertNoDivisions from "./EventCreateFormAlertNoDivisions";

function EventCreateForm({ uid }) {
  const numSteps = 5;
  let todaysDate = new Date().toISOString().slice(0, 10);

  const [formDate, setFormDate] = useState(todaysDate);
  const [formName, setFormName] = useState("");
  const [formIsGolfScoring, setFormIsGolfScoring] = useState(false);
  const [formGame, setFormGame] = useState(1);
  const [formScoringMode, setFormScoringMode] = useState(1);
  const [step, setStep] = useState(1);
  const [selectedDivisions, setSelectedDivisions] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState(1);
  const [selectedVenueName, setSelectedVenueName] = useState("Modist");
  const [isCreatingEvent, setIsCreatingEvent] = useState(false);

  // KP Leagues round selection
  const [rounds, setRounds] = useState([]);
  const [selectedRoundId, setSelectedRoundId] = useState("");
  const [loadingRounds, setLoadingRounds] = useState(false);

  // Fetch rounds from KP Leagues API
  useEffect(() => {
    const fetchRounds = async () => {
      setLoadingRounds(true);

      try {
        const response = await fetch(
          "https://www.kpleagues.com/json_json/events.php",
          {
            method: "GET",
            headers: {
              "X-API-Key": process.env.REACT_APP_KP_LEAGUES_API_KEY,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (data.success && data.data) {
          // Filter to only show events with round_format_id 4, 5, or 9
          const filteredRounds = data.data.filter((round) =>
            ["4", "5", "9"].includes(round.round_format_id)
          );

          // Sort rounds: upcoming events first, then past events
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Reset time to start of day for comparison

          const sortedRounds = filteredRounds.sort((a, b) => {
            const dateA = new Date(a.round_date);
            const dateB = new Date(b.round_date);
            // Check if dates are upcoming (today or future) or past
            const aIsUpcoming = dateA >= today;
            const bIsUpcoming = dateB >= today;

            // If one is upcoming and one is past, upcoming comes first
            if (aIsUpcoming && !bIsUpcoming) return -1;
            if (!aIsUpcoming && bIsUpcoming) return 1;

            // If both are upcoming, sort by date (earliest first)
            if (aIsUpcoming && bIsUpcoming) {
              return dateA - dateB;
            }

            // If both are past, sort by date (most recent first)
            return dateB - dateA;
          });

          setRounds(sortedRounds);
        }
      } catch (error) {
        console.log("Could not fetch rounds - CORS error on localhost:", error);
        // Set empty rounds array on CORS error
        setRounds([]);
      } finally {
        setLoadingRounds(false);
      }
    };
    fetchRounds();
  }, []);

  //get available divisions useDivisions
  const {
    data: divisions,
    status: divisionsStatus,
    // error: divisionsError
  } = useDivisions();

  // Pre-select normal divisions (IDs 1-6) when divisions are loaded
  useEffect(() => {
    if (
      divisionsStatus === "success" &&
      divisions &&
      selectedDivisions.length === 0
    ) {
      const normalDivisionIds = [1, 2, 3, 4, 5, 6];
      const preSelectedDivisions = divisions
        .filter((division) => normalDivisionIds.includes(division.id))
        .map((division) => ({
          division_id: division.id,
          division_name: division.name,
          weekly_payout: 0,
          series_payout: 0,
          event_costs: 0,
          weekly_payout_method: 1,
          series_payout_method: 1,
          layout_id: 1,
        }));
      setSelectedDivisions(preSelectedDivisions);
    }
  }, [divisionsStatus, divisions, selectedDivisions.length]);

  //get available payout methods usePayoutMethods
  const {
    data: payoutMethods,
    // status: payoutMethodsStatus,
    // error: payoutMethodsError
  } = usePayoutMethods();

  //get available layouts useLayouts
  const {
    data: layouts,
    // status: layoutsStatus,
    // error: layoutsError
  } = useLayouts();

  const {
    data: courses,
    status: coursesStatus,
    // error: coursesError
  } = useCourses();

  const {
    data: games,
    // status: gamesStatus,
    // error: gamesError
  } = useGames();

  const {
    data: scoringModes,
    // status: scoringModesStatus,
    // error: scoringModesError,
  } = useThrowScoringModes();

  //create event_divisions data array
  let eventDivisionsData = [];

  //handle submit function
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsCreatingEvent(true);

    //create event data array
    let eventData = {
      name: formName,
      date: formDate,
      is_rebuys: true,
      scoring_order_golf: formIsGolfScoring,
      td_id: uid,
      course_id: selectedVenue,
      game_id: formGame,
      throw_scoring_mode_id: formScoringMode,
      round_id: selectedRoundId || null,
    };

    selectedDivisions.forEach((division) => {
      var totalCost =
        parseInt(division.weekly_payout, 10) +
        parseInt(division.series_payout, 10) +
        parseInt(division.event_costs, 10);

      eventDivisionsData.push({
        division_id: division.division_id,
        division_cost: totalCost,
        series_payout_rake_per_player: division.series_payout,
        division_rake_per_player: division.event_costs,
        layout_id: division.layout_id,
      });
    });

    //add eventData to events table. get event_id for eventDivisionsData, wait for response, then
    createEvent(eventData).then((eventResponse) => {
      //add event to eventDivisionsData
      eventDivisionsData.forEach((eventDivision) => {
        eventDivision.event_id = eventResponse[0].id;
      });

      //add eventDivisions to event_divisions table
      createEventDivisions(eventDivisionsData)
        .then((eventDivisionsResponse) => {
          // redirect to event_manage page
          window.location.href = "/event_manage?event=" + eventResponse[0].id;
        })
        .finally(() => {
          setIsCreatingEvent(false);
        });
    });
  };

  const handleNext = () => {
    setStep(step + 1);
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const handleFormDateChange = (e) => {
    setFormDate(e.target.value);
  };

  const handleFormNameChange = (e) => {
    setFormName(e.target.value);
  };

  const handleFormIsGolfScoringChange = (e) => {
    setFormIsGolfScoring(e.target.checked);
  };

  const handleFormGameChange = (e) => {
    setFormGame(parseInt(e.target.value, 10));
  };

  const handleFormScoringModeChange = (e) => {
    setFormScoringMode(parseInt(e.target.value, 10));
  };

  const handleRoundSelection = (e) => {
    const roundId = e.target.value;
    setSelectedRoundId(roundId);

    if (roundId) {
      // Find the selected round and pre-fill form data
      const selectedRound = rounds.find((round) => round.round_id === roundId);
      if (selectedRound) {
        setFormName(selectedRound.round_name);
        setFormDate(selectedRound.round_date);
      }
    } else {
      // Reset to defaults if no round selected
      setFormName("");
      setFormDate(todaysDate);
    }
  };

  return (
    <Container>
      <Form>
        {step === 1 && (
          <div>
            <h4>Select KP Leagues Round</h4>
            {loadingRounds && <p>Loading rounds...</p>}
            {!loadingRounds && rounds.length === 0 && (
              <div className="alert alert-info mb-3">
                <p>
                  <strong>Note:</strong> KPLeagues round selection not
                  available.
                </p>
                <p>You can still create a custom event using the form below.</p>
              </div>
            )}
            {rounds.length > 0 && (
              <Form.Group className="mb-3">
                <Form.Label>
                  Choose a KP Leagues round to pre-fill event details:
                </Form.Label>
                <Form.Control
                  as="select"
                  value={selectedRoundId}
                  onChange={handleRoundSelection}
                  style={{
                    padding: "8px 12px",
                    lineHeight: "1.5",
                    minHeight: "38px",
                  }}
                >
                  <option value="" style={{ padding: "8px" }}>
                    Create custom event
                  </option>
                  {rounds.map((round) => (
                    <option
                      key={round.round_id}
                      value={round.round_id}
                      style={{ padding: "8px" }}
                    >
                      {round.round_name} - {round.round_date} ({round.round_id})
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            )}

            <EventCreateFormStep1
              games={games}
              formName={formName}
              formDate={formDate}
              formGame={formGame}
              formIsGolfScoring={formIsGolfScoring}
              handleFormNameChange={handleFormNameChange}
              handleFormDateChange={handleFormDateChange}
              handleFormGameChange={handleFormGameChange}
              handleFormIsGolfScoringChange={handleFormIsGolfScoringChange}
              scoringModes={scoringModes}
              formScoringMode={formScoringMode}
              handleFormScoringModeChange={handleFormScoringModeChange}
            />
          </div>
        )}
        {step === 2 && (
          <EventCreateFormStep2
            divisions={divisions}
            divisionsStatus={divisionsStatus}
            selectedDivisions={selectedDivisions}
            setSelectedDivisions={setSelectedDivisions}
          />
        )}

        {/* <EventCreateFormStep3
            selectedDivisions={selectedDivisions}
            setSelectedDivisions={setSelectedDivisions}
            payoutMethods={payoutMethods}
          /> */}
        {step === 3 && (
          <EventCreateFormStep5
            selectedDivisions={selectedDivisions}
            setSelectedDivisions={setSelectedDivisions}
            courses={courses}
            coursesStatus={coursesStatus}
            selectedVenue={selectedVenue}
            setSelectedVenue={setSelectedVenue}
            setSelectedVenueName={setSelectedVenueName}
          />
        )}

        {/* <EventCreateFormStep4
            selectedDivisions={selectedDivisions}
            setSelectedDivisions={setSelectedDivisions}
            payoutMethods={payoutMethods}
          /> */}
        {step === 4 && (
          <EventCreateFormStep6
            layouts={layouts}
            selectedDivisions={selectedDivisions}
            setSelectedDivisions={setSelectedDivisions}
          />
        )}

        {step === 5 && (
          <EventCreateFormStep7
            formName={formName}
            formDate={formDate}
            formIsGolfScoring={formIsGolfScoring}
            formGame={formGame}
            games={games}
            selectedVenueName={selectedVenueName}
            layouts={layouts}
            payoutMethods={payoutMethods}
            selectedDivisions={selectedDivisions}
            setSelectedDivisions={setSelectedDivisions}
            selectedRoundId={selectedRoundId}
            rounds={rounds}
          />
        )}

        <EventCreateFormNav
          step={step}
          numSteps={numSteps}
          formName={formName}
          selectedDivisions={selectedDivisions}
          handleSubmit={handleSubmit}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          isCreatingEvent={isCreatingEvent}
        />

        {step === 1 && formName === "" && <EventCreateFormAlertNoName />}

        {step === 2 && selectedDivisions.length === 0 && (
          <EventCreateFormAlertNoDivisions />
        )}

        <hr />

        <EventCreateFormFooter step={step} numSteps={numSteps} />
      </Form>
    </Container>
  );
}

export default EventCreateForm;
